import { useWidgetAdaptiveText } from '../../../hooks';

import styles from './GeneralWidgetTimer.module.scss';

interface GeneralWidgetTimerProps {
  timerValue: string;
  extended?: boolean;
}

export function GeneralWidgetTimer(props: GeneralWidgetTimerProps) {
  const { timerValue, extended } = props;
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });
  return (
    <div className={extended ? styles.containerExtended : styles.container}>
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {timerValue}
      </span>
    </div>
  );
}
